import { useAppSelector } from "../store";

/**
 * Returns TRUE if 2FA is required, but is not configured yet.
 */
export function useMustConfigure2FA() {
  const twoFactorEnabled = useAppSelector(
    (state) => state.layout.twoFactorAuthRequired
  );
  const twoFactorConfigured = useAppSelector((state) => state.auth.twoFactor);

  return twoFactorEnabled && !twoFactorConfigured;
}
